import type { SxProps, Theme } from '@mui/material';
import { brandSubmissionHeaderSx, brandSubmissionMobileLabelSx } from './brandSubmissionCardLayout';

/** Desktop table row from lg (1200px), except 1280×800 landscape tablet. */
export const BRAND_JUROR_DESKTOP_MIN_PX = 1200;
/** Only this viewport band uses compact cards while still ≥ desktop min width. */
export const BRAND_JUROR_LANDSCAPE_TABLET_MAX_WIDTH_PX = 1280;
export const BRAND_JUROR_LANDSCAPE_TABLET_MAX_HEIGHT_PX = 800;

const landscapeTabletMq = `@media (min-width: ${BRAND_JUROR_DESKTOP_MIN_PX}px) and (max-width: ${BRAND_JUROR_LANDSCAPE_TABLET_MAX_WIDTH_PX}px) and (max-height: ${BRAND_JUROR_LANDSCAPE_TABLET_MAX_HEIGHT_PX}px)`;
const desktopMq = `@media (min-width: ${BRAND_JUROR_DESKTOP_MIN_PX}px)`;

/** Compact juror card — default below lg; also 1280×800 only among wide viewports. */
export const brandJurorCompactVisibleSx: SxProps<Theme> = {
    display: 'block',
    [desktopMq]: {
        display: 'none',
    },
    [landscapeTabletMq]: {
        display: 'block',
    },
};

/** Desktop grid row — lg+ except 1280×800. */
export const brandJurorDesktopVisibleSx: SxProps<Theme> = {
    display: 'none',
    [desktopMq]: {
        display: 'grid',
    },
    [landscapeTabletMq]: {
        display: 'none',
    },
};

/** Column headers — same visibility as desktop row. */
export const brandJurorDesktopHeaderVisibleSx: SxProps<Theme> = {
    display: 'none',
    [desktopMq]: {
        display: 'grid',
    },
    [landscapeTabletMq]: {
        display: 'none',
    },
};

export const brandJurorGridColumns = {
    xs: '1fr',
    lg: 'minmax(140px, 1.55fr) 76px 58px 54px 96px 44px',
} as const;

export const brandJurorGridSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: brandJurorGridColumns,
    columnGap: 3,
    rowGap: 0,
    alignItems: 'center',
    justifyItems: 'unset',
    px: 3,
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
};

export const brandJurorHeaderSx: SxProps<Theme> = {
    ...brandSubmissionHeaderSx,
    whiteSpace: 'normal',
    lineHeight: 1.15,
};

export const brandJurorStackedHeaderSx: SxProps<Theme> = {
    ...brandJurorHeaderSx,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    textAlign: 'center',
    minHeight: 30,
    gap: 0.15,
};

export const brandJurorMobileLabelSx: SxProps<Theme> = {
    ...brandSubmissionMobileLabelSx,
    whiteSpace: 'normal',
    lineHeight: 1.15,
};

export const brandJurorStackedMobileLabelSx: SxProps<Theme> = {
    ...brandJurorMobileLabelSx,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.1,
    mb: 0.75,
};

/** Elite compact card shell (HTML mock). */
export const brandJurorCompactCardSx: SxProps<Theme> = {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 3,
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    bgcolor: 'rgba(26, 26, 26, 0.8)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
};

export const brandJurorCompactStatBoxSx: SxProps<Theme> = {
    bgcolor: 'rgba(14, 14, 14, 0.5)',
    borderRadius: 2,
    p: 2,
    border: '1px solid rgba(72, 72, 71, 0.1)',
};
